module.exports = "query ($id: ID!) {\n  Residential(id: $id) {\n    ...ResidentialDashboard\n  }\n}\n"